module.exports = __webpack_public_path__ + "static/media/12.fb3ea01a.jpg";